import { Icon, IconName } from '@usealloy/component-library';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { UserContext } from '~/dashboard/context';
import { redirectToRuleLibrary } from '~/dashboard/components/Sidebar/useRuleLibrarySession';
import { libraryRoutes } from '~/helpers/api-new/modules/library/libraryRoutes';
import { routes } from '~/helpers/routes';

import { Sidebar } from '../component/Sidebar';
import { isPrefixActive } from './routeMatchers';

/**
 * Admin dashboard nav group — Customers, Services, Notifications, Employees,
 * Policy Library, AI.
 *
 * Items and conditions are ported verbatim from the legacy
 * `~/dashboard/components/Sidebar/AdminSidebarLinks.tsx`.
 */
export const AdminGroup = () => {
  const { agent, featureFlags } = useContext(UserContext);
  const { pathname } = useLocation();
  const handleLibraryClick = (e: { preventDefault: () => void }) => {
    e.preventDefault();
    redirectToRuleLibrary(libraryRoutes.globalRepository.view);
  };

  const isEmployee = agent?.isEmployee;
  const {
    customers, globalServices, notifications, employees, ai,
  } = routes.v3.dashboard.admin;

  const shouldShowLibrary = (featureFlags?.ruleLibraryPhase ?? 0) >= 1;

  return (
    <Sidebar.Group>
      <Sidebar.Menu>
        <Sidebar.MenuItem>
          <Sidebar.MenuButton
            as="a"
            href={`${window.location.origin}${customers.list}`}
            isActive={isPrefixActive(customers.list, pathname)}
            tooltip="Customers"
          >
            <Icon icon={IconName.Customers} size="small" />
            <span className="fs-unmask">Customers</span>
          </Sidebar.MenuButton>
        </Sidebar.MenuItem>

        {isEmployee && (
          <>
            <Sidebar.MenuItem>
              <Sidebar.MenuButton
                as="a"
                href={`${window.location.origin}${globalServices.list}`}
                isActive={isPrefixActive(globalServices.list, pathname)}
                tooltip="Services"
              >
                <Icon icon={IconName.Service} size="small" />
                <span className="fs-unmask">Services</span>
              </Sidebar.MenuButton>
            </Sidebar.MenuItem>

            <Sidebar.MenuItem>
              <Sidebar.MenuButton
                as="a"
                href={`${window.location.origin}${notifications.list}`}
                isActive={isPrefixActive(notifications.list, pathname)}
                tooltip="Notifications"
              >
                <Icon icon={IconName.Email} size="small" />
                <span className="fs-unmask">Notifications</span>
              </Sidebar.MenuButton>
            </Sidebar.MenuItem>

            <Sidebar.MenuItem>
              <Sidebar.MenuButton
                as="a"
                href={`${window.location.origin}${employees.list}`}
                isActive={isPrefixActive(employees.list, pathname)}
                tooltip="Employees"
              >
                <Icon icon={IconName.Employees} size="small" />
                <span className="fs-unmask">Employees</span>
              </Sidebar.MenuButton>
            </Sidebar.MenuItem>

            {shouldShowLibrary && (
              <Sidebar.MenuItem>
                <Sidebar.MenuButton
                  as="a"
                  href={`${window.location.origin}${libraryRoutes.globalRepository.view}`}
                  isActive={isPrefixActive(libraryRoutes.globalRepository.view, pathname)}
                  onClick={handleLibraryClick}
                  tooltip="Policy Library"
                >
                  <Icon icon={IconName.Library} size="small" />
                  <span className="fs-unmask">Policy Library</span>
                </Sidebar.MenuButton>
              </Sidebar.MenuItem>
            )}

            <Sidebar.MenuItem>
              <Sidebar.MenuButton
                as="a"
                href={`${window.location.origin}${ai.view}`}
                isActive={isPrefixActive(ai.view, pathname)}
                tooltip="AI"
              >
                <Icon icon={IconName.Sparkles} size="small" />
                <span className="fs-unmask">AI</span>
              </Sidebar.MenuButton>
            </Sidebar.MenuItem>
          </>
        )}
      </Sidebar.Menu>
    </Sidebar.Group>
  );
};
